import React from "react";
import { Box, Heading, Text, Button } from "@chakra-ui/react";
import { Link } from "react-router-dom";

const Unauthorized = () => {
  return (
    <Box p={8} textAlign="center">
      <Heading size="md" mb={2}>
        Access Denied
      </Heading>
      <Text mb={4}>You don't have access to this module.</Text>
      <Button as={Link} to="/" colorScheme="teal">
        Back to Dashboard
      </Button>
    </Box>
  );
};

export default Unauthorized;
